module.exports = __webpack_public_path__ + "static/media/mtnIcon.d0f28339.svg";